const conditionFragment = /* GraphQL */ `
  fragment condition on Product {
    condition: metafield(namespace: "mm-google-shopping", key: "condition") {
      value
    }
  }
`;

export default conditionFragment;
